import React from 'react';
import PropTypes from 'prop-types';

const sizeClasses = {
  'ellipse-sm': 'w-5.75 h-5.75 rounded-full', // styles according to the mock up with button height 23px
  lg: 'px-3 py-1.5 h-11.5 min-w-29 w-auto flex-shrink-0', // styles according to the mock up with button height 46px, min-width 116px according to the mock up
  md: 'px-3 py-1.5 h-9.5 min-w-20.5 w-auto flex-shrink-0', // styles according to the mock up with button height 38px, min-width 82px according to the mock up
  sm: 'px-3 py-1.5 h-7.75', // styles according to the mock up with button height 31px
  tag: 'px-3 py-1.5 h-9 w-auto flex-shrink-0', // size for tag button
  'md-full': 'px-3 py-1.5 h-9.5 min-w-20.5 w-full flex-shrink-0',
};

const variant = {
  primary: 'bg-vamos-black text-vamos-white hover:bg-vamos-green1',
  secondary: 'bg-vamos-white text-vamos-black border-0.5px border-vamos-black hover:bg-vamos-green2',
  action: 'bg-vamos-green1 text-vamos-white hover:bg-vamos-green2',
  tertiary: 'bg-vamos-blue1 text-vamos-black text-sm font-bold uppercase border', // the label is uppercase according to the design
  'tertiary-notuppercase': 'bg-vamos-blue1 text-vamos-black border',
  'primary-delete': 'bg-vamos-delete font-medium text-vamos-white hover:bg-vamos-delete-hover',
  'secondary-delete': 'text-vamos-red font-normal underline underline-offset-auto decoration-solid', // this is approximate design, waiting from KAte the exact design
};
/* eslint-disable react/button-has-type */
const Button = ({
  label = '',
  onClick = () => { },
  type = 'button',
  className = '',
  size = 'lg',
  Icon = null,
  iconPosition = 'front',
  color = 'primary',
  isDisabled = false,
  gap = 'gap-2',
  fontWeight = 'font-normal',
  dataTestId = undefined,
}) => {
  const buttonColor = variant[color] || variant.primary;
  const disabledClasses = 'opacity-50 cursor-not-allowed';
  // Icon as object here when it is component instance, if we have Icon as component it is a function
  const renderedIcon = typeof Icon === 'object'
    ? Icon
    : <Icon className={`${color === 'text-vamos-white'}`} />;

  const IconInButton = Icon ? renderedIcon : null;

  return (
    <button
      type={type}
      className={`flex ${IconInButton && !size.startsWith('ellipse') ? 'justify-start' : 'justify-center'} items-center ${gap} text-lg ${buttonColor} rounded-md ${className} ${sizeClasses[size]} whitespace-nowrap ${isDisabled ? disabledClasses : ''} ${fontWeight}`}
      onClick={!isDisabled ? onClick : undefined}
      disabled={isDisabled}
      data-testid={dataTestId}
    >
      {iconPosition === 'front' ? (
        <>
          {IconInButton}
          {label}
        </>
      )
        : (
          <>
            {label}
            {IconInButton}
          </>
        )}

    </button>
  );
};

// Prop types for component props validation
Button.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['lg', 'md', 'sm', 'ellipse-sm', 'tag']),
  Icon: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  iconPosition: PropTypes.string,
  label: PropTypes.string,
  color: PropTypes.string,
  isDisabled: PropTypes.bool,
  gap: PropTypes.string,
  fontWeight: PropTypes.string,
  dataTestId: PropTypes.string,
};

export default Button;
